// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","filterWrapper":"projectFilters_filterWrapper__dQrjr","roomsFilter":"projectFilters_roomsFilter__kfgjz","result":"projectFilters_result__AmMfM"};